import type { CompositionRow } from './types';

/**
 * Block 12 PR-D-A Phase D3 Step 4 — default 17 строк раздела «Состав» КП.
 *
 * Per PRD `docs/prd/v4/10-block-12-calculator.md` §10.12.10 «Блок Состав» —
 * exactly **17 entries** (исправление от Excel ТЗ: дубль «Корзина выдвижная»
 * убран, оставлена ОДНА на position 5). Прототип
 * `docs/prototypes/screen-2.12.10-cp.html` lines 45-63 уже отражает это
 * исправление.
 *
 * IDs — стабильные kebab-case slug'и (per TZ Phase D3 Step 4) для
 * traceability в reducer / IDB / analytics. Custom rows используют
 * `genUuid()` (см. SectionComposition.tsx + `@/lib/uuid`).
 *
 * Defaults `itemType` / `brand` — пустые строки. Phase D5 Step 8
 * `deriveCompositionFromAnketa()` overwrite'нет их при seeding из анкеты
 * (например, `countertopKind` → row.itemType для Столешницы). Standalone
 * вход в КП (без `?projectId=`) оставит ячейки пустыми — пользователь
 * заполняет вручную (PRD §10.12.10:388).
 */
export const DEFAULT_COMPOSITION_ROWS: ReadonlyArray<CompositionRow> = [
  { id: 'countertop', name: 'Столешница', itemType: '', brand: '' },
  { id: 'facades', name: 'Фасады', itemType: '', brand: '' },
  { id: 'facade-radius', name: 'Фасад радиусный', itemType: '', brand: '' },
  { id: 'fittings', name: 'Фурнитура', itemType: '', brand: '' },
  { id: 'basket-pullout', name: 'Корзина выдвижная', itemType: '', brand: '' },
  { id: 'foldable-facade', name: 'Складной фасад', itemType: '', brand: '' },
  { id: 'trash-bin', name: 'Мусорное ведро', itemType: '', brand: '' },
  { id: 'laundry-basket', name: 'Корзина для белья', itemType: '', brand: '' },
  { id: 'rod', name: 'Штанга', itemType: '', brand: '' },
  { id: 'pantograph', name: 'Пантограф', itemType: '', brand: '' },
  { id: 'trousers', name: 'Брючница', itemType: '', brand: '' },
  { id: 'ironing-board', name: 'Гладильная доска', itemType: '', brand: '' },
  { id: 'shoe-rack', name: 'Обувница', itemType: '', brand: '' },
  { id: 'vacuum-holder', name: 'Держатель для шланга пылесоса', itemType: '', brand: '' },
  { id: 'lighting', name: 'Подсветка', itemType: '', brand: '' },
  { id: 'vitrine', name: 'Витрина в алюминиевом профиле', itemType: '', brand: '' },
  { id: 'metallic-legs', name: 'Металлические опоры', itemType: '', brand: '' },
];

/** Поле строки, поддерживающее edit (Phase D3 reducer action COMPOSITION_UPDATE). */
export type CompositionField = 'name' | 'itemType' | 'brand';

/**
 * PR-H2 ADR-0027 — Set всех 17 default row id'ов. Используется PARTIAL_RESEED
 * reducer для distinguishing default vs custom rows (custom rows используют
 * `genUuid()` id, никогда не входят в этот Set).
 */
export const DEFAULT_ROW_IDS: ReadonlySet<string> = new Set(
  DEFAULT_COMPOSITION_ROWS.map((r) => r.id),
);
